












import { Vue, Component } from 'nuxt-property-decorator';
import BravadoText from '~/components/common/BravadoText/BravadoText.vue';
import ReferralInvite from '~/components/partials/referral/ReferralInvite/ReferralInvite.vue';

import ReferralIcon from '~/assets/svg/referral-symbol.vue.svg';

@Component({
  components: {
    BravadoText,
    ReferralInvite,
    ReferralIcon,
  },
})
export default class HeaderReferralSection extends Vue {}
